import { useActivation } from '@context/MobileOne';
import { ButtonPrimary, ScrollToTop } from '@core/index';
import { CardAutotopup } from '@core/CardAutotopup';
import { CardSupport } from '@core/CardSupport';
import { NavigationPageTitle } from '@core/NavigationPageTitle';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import {
  appButtonType,
  appCardStyle,
  appChipStyle,
  appIconsPath,
  appLinkStyle,
  appRoute
} from '@utils/globalConstant';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export function AutoTopupInitialization() {
  // Contexts
  const {
    withAutoTopup,
    setWithAutoTopup,
    setStep9SubStep,
    setShowActivationHeader,
    setErrorAutoTopup,
    nextStep
  } = useActivation();

  // const
  const navigate = useNavigate();
  const cardHeaderContent = tA11y('ek_reg_auto_top_up_hdl2');
  const cardTextContent = tA11y('ek_reg_auto_top_up_rec_txt1');
  const buttonContent = tA11y('ek_reg_auto_top_up_btn1');
  const button2Content = tA11y('ek_reg_auto_top_up_btn2');

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100 payment-data-container">
          <AppPageContentWrapper>
            <div className="w-100">
              <NavigationPageTitle title="ek_reg_auto_top_up_hdl1" variant="sm" />
            </div>
            <div className="space-32" />

            <div className="w-100 pb-40">
              <CardAutotopup
                cardStyle={appCardStyle.PRIMARY_GRADIENT}
                chipIcon={appIconsPath.STAR}
                chipStyle={appChipStyle.HIGHLIGHT}
                chipLabel="ek_reg_auto_top_up_rec_badge_txt1"
                cardTitle={cardHeaderContent?.content}
                text={cardTextContent.content}
                buttonContent={buttonContent}
                redirectionStyle={appLinkStyle.SECONDARY}
                redirectionLabel="ek_reg_auto_top_up_lnk1"
                handleLinkClick={() => {
                  setStep9SubStep(1);
                  setShowActivationHeader(false);
                }}
                handleButtonClick={() => setStep9SubStep(2)}
              />
            </div>

            <div className="w-100 d-flex justify-content-center pb-40">
              <div className="col-xxl-5 col-lg-5 col-10 px-0">
                <ButtonPrimary
                  buttonType={appButtonType.WHITE}
                  buttonContent={button2Content}
                  onClick={() => {
                    nextStep();
                    setShowActivationHeader(false);
                  }}
                />
              </div>
            </div>
            {/* <CardSupport /> */}
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default AutoTopupInitialization;
